import React from "react";
import SidebarAdmin from "../../components/SidebarAdmin";
import TopBarTenagaKesehatanDetailAdmin from "../../components/TopBarTenagaKesehatanDetailAdmin";
import EditProfileTenagaKesehatanAdmin from "../../components/EditProfileTenagaKesehatanAdmin";
import "../../CSS/ProfileTenagaKesehatan.css";

function HalamanProfileTenagaKesehatanAdmin() {
  return (
    <div className="profile-page-layout">
      {/* Sidebar kiri */}
      <SidebarAdmin />

      {/* Area kanan */}
      <div className="content">
        <TopBarTenagaKesehatanDetailAdmin />

        {/* Konten utama */}
        <div className="main-contentprofile">
          <EditProfileTenagaKesehatanAdmin />
        </div>

        
      </div>
    </div>
  );
}

export default HalamanProfileTenagaKesehatanAdmin;
